import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import ChangeApp from './ChangeAPP';

const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
<ChangeApp />);
